// Tokens visuais iguais aos do Dashboard de Operação (Novo)
// (pages/dashboard/components/commonDashboardCard), para as duas telas do menu não parecerem
// produtos diferentes. Replicado aqui em vez de importar o componente da outra página para não
// acoplar um dashboard ao outro — se um dia virar um componente comum, os dois passam a usá-lo.
export const dashboardCardSx = {
  height: '100%',
  border: '1px solid #e5e9f0',
  borderRadius: '10px',
  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.05)',
  backgroundColor: '#ffffff'
};

export default dashboardCardSx;
